import { Request } from '~src/httpClient/serverApi/requests/Request';

import { ITriggerBundleUploadParams } from '../types/IBundleUpload';
import { IExecution } from '../types/IExecution';

/**
 * The VizPortal `triggerUpload` Web Client method (WebClientContentMobilityAppService.triggerUpload,
 * W-23797339). Once the house upload session is complete, this queues the run-now upload task: the
 * worker assembles the staged chunks, calls `startUpload`, puts the bundle into the cell filestore
 * through SOS, and signals `completeUpload`. Resolves with a QUEUED execution carrying the
 * `backgroundJobId` to poll. Identity/site come from the authenticated actor, never the payload.
 */
export class TriggerBundleUploadRequest extends Request<ITriggerBundleUploadParams, IExecution> {
  constructor(params: ITriggerBundleUploadParams) {
    super('triggerUpload', params);
  }
}
